import { AppRoute } from 'src/pages';
import { TagList } from './list';

export const tagSettingsRoutes: AppRoute[] = [
  {
    path: 'settings/tags',
    element: <TagList />,
  },
];
